import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle,
  faMinusCircle,
  faTimesCircle
} from '@fortawesome/free-solid-svg-icons'

import { SG, SLR, PB70T } from '@h2/components/colors'

const RedX = styled(FontAwesomeIcon).attrs({ icon: faTimesCircle })`
  color: ${SLR};
  font-size: 18px;
`
const GreenCheck = styled(FontAwesomeIcon).attrs({ icon: faCheckCircle })`
  color: ${SG};
  font-size: 18px;
`
const GrayMinus = styled(FontAwesomeIcon).attrs({ icon: faMinusCircle })`
  color: ${PB70T};
  font-size: 18px;
`

export { RedX, GreenCheck, GrayMinus }
